<template>
  <div>
    <Main
      ref="main"
      :disabled="disabled"
      :amzReplenishmentCode="amzReplenishmentCode"
    />
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    amzReplenishmentCode: { type: String, default: '' },
  },
  data() {
    return {
    }
  },
  methods: {
  },
}
</script>
